import { css } from "@emotion/react";

import { Size } from "@shared/types/sizes";

export const contentWrapper = {
  base: css`
    padding: 1.5rem;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
  `,
  [Size.LARGE]: css`
    width: 100%;
    flex-shrink: 1;
    flex-direction: column;
    flex: auto 1 1;
  `,
  [Size.MEDIUM]: css`
    width: 50%;
  `,
  [Size.XSMALL]: css`
    width: 41.67%;
  `,
  [Size.SMALL]: css`
    width: 58.33%;
  `,
  noPadding: css`
    padding: 0 !important;
  `,
};
